class ProductLinks extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(event) {
    const anchor = event.target.closest('a[href]');
    if (!anchor || !this.contains(anchor)) return;

    const configurator = document.querySelector('product-configurator:not([data-type="cart"])');
    if (!configurator || !configurator.options) return;

    const optionEntries = Object.entries(configurator.options).filter(([, value]) => value);
    if (optionEntries.length === 0) return;

    try {
      const url = new URL(anchor.getAttribute('href'), window.location.origin);
      for (const [key, value] of optionEntries) {
        url.searchParams.set(key, value);
      }
      anchor.href = url.toString();
    } catch (error) {
      // Invalid URL — leave the anchor untouched so navigation falls back to the original href.
    }
  }
}

customElements.define('product-links', ProductLinks);
